import * as z from "zod";

/**
 * Schema for email channel statistics
 */
const emailChannelStatsSchema_ = z.object({
  /** Total email messages sent */
  messagesSent: z.number(),
  /** Unique open rate as percentage (0-100) */
  openRate: z.number(),
  /** Unique click rate as percentage (0-100) */
  clickRate: z.number(),
});
export const emailChannelStatsSchema: z.ZodType<EmailChannelStats> =
  emailChannelStatsSchema_;
export interface EmailChannelStats
  extends z.infer<typeof emailChannelStatsSchema_> {}

/**
 * Schema for SMS channel statistics
 */
const smsChannelStatsSchema_ = z.object({
  /** Total SMS messages sent */
  messagesSent: z.number(),
  /** Unique click rate as percentage (0-100) */
  clickRate: z.number(),
});
export const smsChannelStatsSchema: z.ZodType<SmsChannelStats> =
  smsChannelStatsSchema_;
export interface SmsChannelStats
  extends z.infer<typeof smsChannelStatsSchema_> {}

/**
 * Schema for variant/control group message statistics
 */
const groupMessageStatsSchema_ = z.object({
  email: emailChannelStatsSchema,
  sms: smsChannelStatsSchema,
});
export const groupMessageStatsSchema: z.ZodType<GroupMessageStats> =
  groupMessageStatsSchema_;
export interface GroupMessageStats
  extends z.infer<typeof groupMessageStatsSchema_> {}

const messageStatsOutputSchema_ = z.object({
  /** Marketing agent (variant) message stats */
  variant: groupMessageStatsSchema,
  /** Legacy automations (control) message stats */
  control: groupMessageStatsSchema,
});
export const messageStatsOutputSchema: z.ZodType<MessageStatsOutput> =
  messageStatsOutputSchema_;
export interface MessageStatsOutput
  extends z.infer<typeof messageStatsOutputSchema_> {}

export const getMarketingAgentMessageStats = {
  name: "getMarketingAgentMessageStats" as const,
  input: z.object({
    /** Max number of days to look back */
    days: z.number(),
    splitId: z.string().optional(),
  }),
  output: messageStatsOutputSchema.nullable(),
};
